import { HOSPITALIZATION_OPTIONS } from '@/components/AttendanceForm/atopicdermatitis/constants/hospitalization'
import {
  ATOPIA_OPTIONS,
  FAMILY_DEGREES,
  SYMPTOM_OPTIONS,
} from '@/components/AttendanceForm/atopicdermatitis/constants/symptom'

import AtopicDermatitisHospitalizationsPhase from '@/components/AttendanceForm/atopicdermatitis/phase/AtopicDermatitisHospitalizationsPhase'
import AtopicDermatitisHypothesisPhase from '@/components/AttendanceForm/atopicdermatitis/phase/AtopicDermatitisHypothesisPhase'
import AtopicDermatitisScoresPhase from '@/components/AttendanceForm/atopicdermatitis/phase/AtopicDermatitisScoresPhase'
import AtopicDermatitisSymptomsPhase from '@/components/AttendanceForm/atopicdermatitis/phase/AtopicDermatitisSymptomsPhase'
import AtopicDermatitisHypothesis from '@/components/AttendanceForm/atopicdermatitis/summary/AtopicDermatitisHypothesis.vue'
import AtopicDermatitisSummary from '@/components/AttendanceForm/atopicdermatitis/summary/AtopicDermatitisSummary'
import DlqiPhase from '@/components/AttendanceForm/general/phase/DlqiPhase.vue'
import ExaminationsPhase from '@/components/AttendanceForm/general/phase/ExaminationsPhase'
import FamilyHistoryPhase from '@/components/AttendanceForm/general/phase/FamilyHistoryPhase.vue'
import FlaresPhase from '@/components/AttendanceForm/general/phase/FlaresPhase.vue'
import ImagePhase from '@/components/AttendanceForm/general/phase/ImagePhase.vue'
import LmePhase from '@/components/AttendanceForm/general/phase/LmePhase.vue'
import MedicinesPhase from '@/components/AttendanceForm/general/phase/MedicinesPhase.vue'
import PersonalHistoryPhase from '@/components/AttendanceForm/general/phase/PersonalHistoryPhase.vue'
import PsychiatricScreeningPhase from '@/components/AttendanceForm/general/phase/PsychiatricScreeningPhase.vue'
import ReportPhase from '@/components/AttendanceForm/general/phase/ReportPhase.vue'
import SanofiTreatmentPhase from '@/components/AttendanceForm/general/phase/SanofiTreatmentPhase'
import TreatmentPhase from '@/components/AttendanceForm/general/phase/TreatmentPhase'
import VaccinationPhase from '@/components/AttendanceForm/general/phase/VaccinationPhase.vue'
import { MEDICINE_CATEGORIES } from '@/constants/medicine'

import { util } from '@/plugins/util'
import store from '@/store'
import moment from 'moment'

import { ECustomSummmarizedflow } from '@/constants/customSummarizedFlow'
import { AttendanceConfig } from './AttendanceConfig'
import {
  generateFamilyHistoryOverview,
  generateNotesOverview,
  generatePersonalHistoryOverview,
  generatePsychiatricScreenOverview,
} from './defaultConfig'

const newAttendance = new AttendanceConfig()
  .addStep('Anamnese')
  .addPhase('sintomas', 'Sintomas', AtopicDermatitisSymptomsPhase, generateSymptomsOverview)
  .addPhase(
    'tratamentos_previos',
    'Tratamentos Prévios',
    store.getters['auth/pharmaceuticalDomainConfig'].CUSTOMSUMMARIZEDFLOW === ECustomSummmarizedflow.SANOFI
      ? SanofiTreatmentPhase
      : TreatmentPhase,
    generatePreviousTreatmentsOverview,
  )
  .addPhase(
    'internacoes',
    'Internações',
    AtopicDermatitisHospitalizationsPhase,
    generateHospitalizationOverview,
    store.getters['auth/pharmaceuticalDomainConfig'].CUSTOMSUMMARIZEDFLOW != ECustomSummmarizedflow.SANOFI,
  )
  .addPhase(
    'investigacao_pessoal',
    'Investigação pessoal',
    PersonalHistoryPhase,
    generatePersonalHistoryOverview,
    store.getters['auth/pharmaceuticalDomainConfig'].CUSTOMSUMMARIZEDFLOW != ECustomSummmarizedflow.SANOFI,
  )
  .addPhase(
    'investigacao_familiar',
    'Investigação familiar',
    FamilyHistoryPhase,
    generateFamilyHistoryOverview,
    store.getters['auth/pharmaceuticalDomainConfig'].CUSTOMSUMMARIZEDFLOW != ECustomSummmarizedflow.SANOFI,
  )
  .addPhase(
    'triagem_psiquiatrica',
    'Triagem psiquiátrica',
    PsychiatricScreeningPhase,
    generatePsychiatricScreenOverview,
    store.getters['auth/pharmaceuticalDomainConfig'].CUSTOMSUMMARIZEDFLOW != ECustomSummmarizedflow.SANOFI,
  )
  .addPhase(
    'crises',
    'Crises (Flares)',
    FlaresPhase,
    generateNotesOverview,
    store.getters['auth/pharmaceuticalDomainConfig'].CUSTOMSUMMARIZEDFLOW != ECustomSummmarizedflow.SANOFI,
  )
  .addStep('Exame físico')
  .addPhase('score', 'Scores', AtopicDermatitisScoresPhase)
  .addPhase(
    'exames',
    'Exames',
    ExaminationsPhase,
    undefined,
    store.getters['auth/pharmaceuticalDomainConfig'].CUSTOMSUMMARIZEDFLOW != ECustomSummmarizedflow.SANOFI,
  )
if (store.getters['auth/pharmaceuticalDomainConfig'].CUSTOMSUMMARIZEDFLOW !== ECustomSummmarizedflow.SANOFI) {
  newAttendance.addPhase(
    'dlqi',
    'DLQI',
    DlqiPhase,
    generateNotesOverview,
    store.getters['auth/pharmaceuticalDomainConfig'].CUSTOMSUMMARIZEDFLOW != ECustomSummmarizedflow.SANOFI,
  )
}
newAttendance
  .addPhase(
    'vacinas',
    'Vacinas',
    VaccinationPhase,
    undefined,
    store.getters['auth/pharmaceuticalDomainConfig'].CUSTOMSUMMARIZEDFLOW != ECustomSummmarizedflow.SANOFI,
  )
  .addPhase('imagens', 'Imagens', ImagePhase, undefined)
  .addStep('Resultados')
  .addPhase(
    'hipotese',
    'Hipótese',
    AtopicDermatitisHypothesisPhase,
    undefined,
    store.getters['auth/pharmaceuticalDomainConfig'].CUSTOMSUMMARIZEDFLOW != ECustomSummmarizedflow.SANOFI,
  )
  .addPhase('medicamentos', 'Medicamentos', MedicinesPhase, generateMedicineHistoryOverview)
  .addPhase(
    'lme',
    'LME',
    LmePhase,
    false,
    store.getters['auth/pharmaceuticalDomainConfig'].CUSTOMSUMMARIZEDFLOW != ECustomSummmarizedflow.SANOFI,
  )
  .addPhase(
    'relatorio',
    'Relatório',
    ReportPhase,
    undefined,
    store.getters['auth/pharmaceuticalDomainConfig'].CUSTOMSUMMARIZEDFLOW != ECustomSummmarizedflow.SANOFI,
  )
  .setSummaryComponent(AtopicDermatitisSummary)
  .setHypothesisComponent(AtopicDermatitisHypothesis)

export default newAttendance

function generateSymptomsOverview(data, attendance) {
  if (!data) {
    return []
  }

  const paragraphs = []

  paragraphs.push(`O paciente já tem diagnóstico de Dermatite atópica? ${data.has_diagnosis?.value ? 'Sim' : 'Não'} `)

  if (!!data.has_diagnosis?.specialty) {
    paragraphs.push(`Diagnóstico com: ${data.has_diagnosis?.specialty.specialtyName}`)
  }

  if (!!data.has_diagnosis?.date) {
    paragraphs.push(`Feito no dia: ${moment(data.has_diagnosis.date).format('DD/MM/YYYY')}`)
  }
  paragraphs.push('Quais sintomas o paciente apresenta?')

  paragraphs.push('<b>Critérios Maiores</b>')

  const majorSymptoms = data.symptoms.maiores.selected
    .filter((symptom) => symptom != 'atopia')
    .map((selectedSymptom) => SYMPTOM_OPTIONS.maiores.find((symptom) => symptom.key === selectedSymptom).name)
    .join(', ')

  const selectedAtopias = data.symptoms.maiores.atopia.value

  const atopiaOptions = data.symptoms.maiores.atopia.options
    .filter((option) => selectedAtopias.includes(option.key))
    .map((option) => getAtopiaString(option))
    .join(', ')

  paragraphs.push(majorSymptoms)

  paragraphs.push(atopiaOptions)

  paragraphs.push('')

  paragraphs.push('<ul><b>Critérios Menores</b>')

  const facialSymptoms = data.symptoms.menores.faciais.selected.map(
    (selectedSymptom) => SYMPTOM_OPTIONS.menores[0].symptoms.find((symptom) => symptom.key === selectedSymptom).name,
  )

  facialSymptoms.forEach((symptom) => paragraphs.push('<li>' + symptom + '</li>'))

  const triggers = data.symptoms.menores.triggers.selected.map(
    (selectedSymptom) => SYMPTOM_OPTIONS.menores[1].symptoms.find((symptom) => symptom.key === selectedSymptom).name,
  )

  paragraphs.push('Triggers:')
  triggers.forEach((symptom) => paragraphs.push('<li>' + symptom + '</li>'))

  const complications = data.symptoms.menores.complicacoes.selected.map(
    (selectedSymptom) => SYMPTOM_OPTIONS.menores[2].symptoms.find((symptom) => symptom.key === selectedSymptom).name,
  )

  paragraphs.push('Complicações:')
  complications.forEach((symptom) => paragraphs.push('<li>' + symptom + '</li>'))

  const others = data.symptoms.menores.outros.selected.map(
    (selectedSymptom) => SYMPTOM_OPTIONS.menores[3].symptoms.find((symptom) => symptom.key === selectedSymptom).name,
  )

  paragraphs.push('Outros:')
  others.forEach((symptom) => paragraphs.push('<li>' + symptom + '</li>'))
  paragraphs.push('</ul>')

  paragraphs.push(...generateNotesOverview(data, attendance))

  return paragraphs
}

function getAtopiaString(option) {
  const paragraphs = []

  const symptomName = ATOPIA_OPTIONS.find((symptom) => symptom.key === option.key).name

  if (option.who.includes('paciente')) {
    paragraphs.push(`${symptomName} no paciente`)
  }
  if (option.who.includes('familiar')) {
    const familyText = []
    familyText.push(` ${symptomName} no familiar`)
    if (option.degree.length > 0) {
      familyText.push(
        option.degree
          .map((degree) => FAMILY_DEGREES.find((familyDegree) => familyDegree.key === degree).name)
          .join(' e '),
      )
      paragraphs.push(familyText.join(', '))
    } else {
      paragraphs.push(familyText)
      paragraphs.join(', ')
    }
  }

  return paragraphs
}

function generatePreviousTreatmentsOverview(data, attendance) {
  if (!data) {
    return []
  }

  const paragraphs = []

  const selectedTreatments = Object.keys(data.medicines || {})
    .map((key) => data.medicines[key])
    .sort(util.objectSorter((item) => item.medicine.category.name.toLowerCase() + item.medicine.name.toLowerCase()))

  const currentTreatments = selectedTreatments
    .filter((medicine) => medicine.periods.length === 0 || !medicine.periods.find((period) => period.end))
    .map((medicine) => formattedCurrentMedicineText(medicine))

  const previousAntihistamines = selectedTreatments
    .filter(
      (m) => m.medicine.category.id === MEDICINE_CATEGORIES.ANTI_HISTAMINICOS && m.periods.find((period) => period.end),
    )
    .map((medicine) => formattedPreviousMedicineText(medicine))

  const previousImmunobiologicalTreatments = selectedTreatments
    .filter(
      (m) => m.medicine.category.id === MEDICINE_CATEGORIES.IMUNOBIOLOGICOS && m.periods.find((period) => period.end),
    )
    .map((medicine) => formattedPreviousMedicineText(medicine))

  const previousTopicalTreatments = selectedTreatments
    .filter((m) => m.medicine.category.id === MEDICINE_CATEGORIES.TOPICOS && m.periods.find((period) => period.end))
    .map((medicine) => formattedPreviousMedicineText(medicine))

  const previousSistemicTreatments = selectedTreatments
    .filter(
      (m) =>
        m.medicine.category.id === MEDICINE_CATEGORIES.SISTEMICOS_TRADICIONAIS &&
        m.periods.find((period) => period.end),
    )
    .map((medicine) => formattedPreviousMedicineText(medicine))

  const previousMoisturizerTreatments = selectedTreatments
    .filter((m) => m.medicine.category.id === MEDICINE_CATEGORIES.HIDRATANTES && m.periods.find((period) => period.end))
    .map((medicine) => formattedPreviousMedicineText(medicine))

  const previousAntibioticTreatments = selectedTreatments
    .filter(
      (m) => m.medicine.category.id === MEDICINE_CATEGORIES.ANTIBIOTICOS && m.periods.find((period) => period.end),
    )
    .map((medicine) => formattedPreviousMedicineText(medicine))

  paragraphs.push(
    `Histórico de medicamentos: `,
    `- Medicamentos atuais: ${currentTreatments.length > 0 ? currentTreatments : 'nenhum'};`,
    `-  Anti-histamínicos prévios: ${previousAntihistamines.length > 0 ? previousAntihistamines : 'nenhum'};`,
    `- Imunobiológicos ou pequenas moléculas prévios: ${
      previousImmunobiologicalTreatments.length > 0 ? previousImmunobiologicalTreatments : 'nenhum'
    };`,
    `- Tópicos prévios: ${previousTopicalTreatments.length > 0 ? previousTopicalTreatments : 'nenhum'}.`,
    `- Sistêmicos tradicionais prévios: ${
      previousSistemicTreatments.length > 0 ? previousSistemicTreatments : 'nenhum'
    }.`,
    `- Hidratantes prévios: ${previousMoisturizerTreatments.length > 0 ? previousMoisturizerTreatments : 'nenhum'}.`,
    `- Antibióticos prévios: ${previousAntibioticTreatments.length > 0 ? previousAntibioticTreatments : 'nenhum'}.`,
  )

  return paragraphs
}

function formattedCurrentMedicineText(medicine) {
  return `${medicine.medicine.name.firstLetterToLowercase()}${
    medicine.periods.length === 0 || medicine.periods.some((p) => !p.start)
      ? ''
      : ' (desde ' + util.toFormattedDate(medicine.periods.find((p) => !p.end).start) + ')'
  }`
}

function formattedPreviousMedicineText(medicine) {
  return `${medicine.medicine.name.firstLetterToLowercase()}`
}

function generateMedicineHistoryOverview(data, attendance) {
  if (!data) {
    return []
  }

  const paragraphs = []

  const medicines = data.selectedTreatments.map((treatment) => treatment.medicine.name).join(', ')

  paragraphs.push(medicines.length > 0 ? `Medicamentos atuais: ${medicines}` : 'Nenhum medicamento prescrito.')

  paragraphs.push(...generateNotesOverview(data, attendance))

  return paragraphs
}

function generateHospitalizationOverview(data, attendance) {
  if (!data) {
    return []
  }

  const paragraphs = []

  data.hospitalizations.forEach((hospitalization, index) => {
    paragraphs.push(`<b>Internação #${index + 1}</b>`)

    const locations = Object.values(hospitalization.location)
      .filter((location) => location.selected)
      .map((location) => ({
        label: HOSPITALIZATION_OPTIONS.location.find((loc) => loc.key === location.selected).label,
        time: moment(location.time.end).diff(location.time.start, 'days'),
      }))

    locations.forEach((location) =>
      paragraphs.push(
        `\n\tLocal de internação: ${location.label}, ${location.time} ${location.time > 1 ? 'dias' : 'dia'}`,
      ),
    )

    const reasons = hospitalization.reason.selected
      .filter((key) => key !== 'outros')
      .map((key) => HOSPITALIZATION_OPTIONS.reason.find((reason) => reason.key === key).label)
      .join(', ')

    const otherReasons = hospitalization.reason.other

    paragraphs.push(`Motivo principal da Internação: ${reasons}`)
  })

  return paragraphs
}
